import React from 'react';
import { LOG_STATE, LOG_STATE_DEFINITIONS } from '../logs.utils';

const KPI_ORDER = [
  LOG_STATE.INTERVENTION_REQUIRED,
  LOG_STATE.AUTO_RETRY,
  LOG_STATE.PENDING,
  LOG_STATE.DONE,
];

/**
 * Compteurs par état. Un clic filtre la liste sur l'état, un second clic retire le filtre.
 */
export default function LogsKpis({ stats, selectedState, onSelectState }) {
  return (
    <div className="tw-grid tw-grid-cols-4 mq1050:tw-grid-cols-2 tw-gap-3">
      {KPI_ORDER.map((state) => {
        const definition = LOG_STATE_DEFINITIONS[state];
        const isSelected = selectedState === state;
        const count = stats ? stats[state] ?? 0 : null;
        const isAlert =
          state === LOG_STATE.INTERVENTION_REQUIRED && Number(count) > 0;

        return (
          <button
            key={state}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onSelectState(isSelected ? '' : state)}
            className={`tw-flex tw-flex-col tw-items-start tw-gap-1 tw-p-4 tw-text-left tw-rounded-md tw-bg-white tw-border tw-border-solid tw-transition-colors hover:tw-border-main/40 ${
              isSelected
                ? 'tw-border-main tw-ring-1 tw-ring-main'
                : 'tw-border-black/10'
            }`}
          >
            <span className="tw-flex tw-items-center tw-gap-2 tw-text-xs tw-font-semibold tw-font-work tw-text-text-dark-medium-importance tw-uppercase tw-tracking-wide">
              <span
                className={`tw-inline-block tw-size-2 tw-rounded-full ${definition.color}`}
                aria-hidden="true"
              />
              {definition.label}
            </span>
            <span
              className={`tw-text-2xl tw-font-semibold tw-leading-7 ${
                isAlert ? 'tw-text-status-negative' : ''
              }`}
            >
              {count === null ? '—' : count.toLocaleString('fr-FR')}
            </span>
            <span className="tw-text-xs tw-font-work tw-text-text-dark-medium-importance">
              {definition.description}
            </span>
          </button>
        );
      })}
    </div>
  );
}
